import React from 'react';
import { translate } from 'javascripts/translations/i18n';
import { Text, Menu, ButtonIcon, MenuItem } from '@companycam/slab-web';
import CCLogo from 'images/CC-Logo-Mark.png';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: var(--cc_size_spacing_m) 0;
  padding: 0 var(--cc_size_spacing_s);
  min-height: 8%;
`;

const TemplateInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  cursor: pointer;
`;

const StyledMenu = styled(Menu)`
  max-width: 280px;
  min-width: 224px;
`;

const ExampleTemplateRow = styled.div`
  display: flex;
  align-items: center;
`;

const CompanyLogo = styled.img`
  width: 30px;
  height: 30px;
  margin: var(--cc_size_spacing_s) var(--cc_size_spacing_s)
    var(--cc_size_spacing_s) 0;
`;

type TemplateRowProps = {
  title: string;
  description?: string;
  lastUsedAt: string;
  isExample: boolean;
  onClick: () => void;
  onPreviewClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
};

const TemplateRow = ({
  title,
  description,
  lastUsedAt,
  isExample,
  onClick,
  onPreviewClick,
  onEditClick,
  onDeleteClick,
}: TemplateRowProps) => {
  return (
    <Row data-testid="project__pages-templates-row">
      <TemplateInfo onClick={onClick}>
        <Text as="p" family="heading" size="m" weight="600">
          {title}
        </Text>
        <Text as="p" color="subtle">
          {description}
        </Text>
        {lastUsedAt ? (
          <Text as="p" color="subtle">
            {`${translate('common.lastUsed')} ${lastUsedAt}`}
          </Text>
        ) : null}

        {isExample ? (
          <ExampleTemplateRow>
            <CompanyLogo src={CCLogo} alt="CompanyCam Logo" />
            <Text as="p" color="subtle">
              {translate('projectPage.usePageTemplateModal.exampleTemplates')}
            </Text>
          </ExampleTemplateRow>
        ) : null}
      </TemplateInfo>

      <StyledMenu
        triggerButton={
          <ButtonIcon
            accessibilityLabel={translate(
              'useTemplateModal.dropdownArrowAccessibilityLabel',
            )}
            iconName="dots-horizontal"
            size="small"
          />
        }
        mountNodeId="template-modal"
      >
        <MenuItem iconName="eye-outline" onClick={onPreviewClick}>
          {translate('useTemplateModal.previewButtonLabel')}
        </MenuItem>
        {!isExample ? (
          <MenuItem iconName="pencil-outline" onClick={onEditClick}>
            {translate('useTemplateModal.editButtonLabel')}
          </MenuItem>
        ) : null}
        {!isExample ? (
          <MenuItem iconName="trash-can-outline" onClick={onDeleteClick}>
            {translate('common.delete')}
          </MenuItem>
        ) : null}
      </StyledMenu>
    </Row>
  );
};

export default TemplateRow;
